import type { Socket as SocketType } from "socket.io-client";

/**
 * Dynamically imports socket.io-client to reduce the initial bundle size.
 * Returns a connected socket instance.
 */
export async function createSocket(
  endpoint: string,
  options: Parameters<typeof import("socket.io-client").io>[1]
): Promise<SocketType> {
  const { io } = await import("socket.io-client");
  return io(endpoint, options);
}

export type { Socket } from "socket.io-client";
